import { Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { ContextService } from '../../services/context/context.service';
import { DataService } from '../../services/context/data.service';
import { RefDataService } from '../../services/context/ref-data.service';
import { UIStateService } from '../../services/context/uistate.service';
import * as fromModel from '../../services/models';
import { MatDialog } from '@angular/material/dialog';
import { EditIncomeComponent } from '../edit-income/edit-income.component';
import { Utils } from '../../../utils/utils';
import { MatMenuTrigger } from '@angular/material/menu';
import { EditExpenseComponent } from '../edit-expense/edit-expense.component';

@Component({
  selector: 'gp-family-view',
  templateUrl: './family-view.component.html',
  styleUrls: ['./family-view.component.scss']
})
export class FamilyViewComponent implements OnInit, OnDestroy {

  //@ViewChild('elemIncome') elemIncome: ElementRef;

  // @ViewChild('incomeMenuEle') incomeMenuEle: ElementRef;

  //@ViewChild(MatMenuTrigger) private menuTrigger: MatMenuTrigger;
  // @ViewChild('incomeMenuTrigger') incomeMenuTrigger: MatMenuTrigger;
  // @ViewChild('goalMenuTrigger') goalMenuTrigger: MatMenuTrigger;
  
  plan: fromModel.Plan;
  planClients: fromModel.PlanClient[];
  planOwners: fromModel.PlanClient[];
  allClients: any[];
  goals = [];
  incomes;
  refreshInc;
  refreshExp;
  refreshAcc;

  pId;
  sId;
  pName;
  sName;
  pEmpType;
  sEmpType;
  incomeColor;
  totalIncome;  
  pEmpIncome;
  sEmpIncome;
  
  assetsColor;
  totalTaxableAssets;
  totalTaxDefAssets;
  totalTaxExemptAssets;
  taxableColor;
  taxDefColor;
  taxExemptColor;
  
  goalId;

  incomeTop;

  showAssetSummary = false;
  showIncomeSummary = false;

  //protected _storeAppContextSubscription: Subscription;
  protected _storeDataSubscription: Subscription;
  

  constructor(private contextService: ContextService,
              private uiStateService: UIStateService,  
              private dataService: DataService,
              private refDataService: RefDataService,
              private dialog: MatDialog) { 
      //this._storeAppContextSubscription = this.contextService.subscribe((appContext:fromModel.IAppContext) => this.populateAppContext(appContext));
      this._storeDataSubscription = this.dataService.subscribe((appData: fromModel.IAppData) => this.populateAppData(appData));   
  }

  ngOnInit(): void {
    this.plan = this.dataService.appData.Plan;
    //this.incomeTop = this.elemIncome.nativeElement.offsetTop;    
  }

  reloadIncomeSummary(){

    //this.incomeMenuEle
    //this.incomeMenuTrigger.openMenu();
    this.refreshInc = Utils.newGuid();
  }

  reloadExpenseSummary(){
    this.refreshExp = Utils.newGuid();
  }

  reloadAccountSummary(){
    this.refreshAcc = Utils.newGuid();
  }

  
  showIncomeSummaryPanel(){
    this.closeAllSummaryPanels();
    this.refreshExp = Utils.newGuid();
    this.showIncomeSummary = !this.showIncomeSummary;
  }

  showAssetSummaryPanel(){
    this.closeAllSummaryPanels();
    this.refreshAcc = Utils.newGuid();
    this.showAssetSummary = !this.showAssetSummary;
  }

  @HostListener('document:click', ['$event']) onDocumentClick(event) {
    this.closeAllSummaryPanels();
  }

  closeAllSummaryPanels(){
    this.showIncomeSummary = false;
    this.showAssetSummary = false;
  }


  // populateClients(clients){
  //   if(clients && clients.value && clients.value.length>0) {
  //     this.allClients = clients.value; 

  //   }    
  // }
  

  populateAppData(appData: fromModel.IAppData){  
    if(appData && appData.action !== fromModel.DATA_ACTION.NONE){
      this.plan = <fromModel.Plan>appData.Plan;
      if(this.plan && this.plan.planClients && this.plan.planClients.length>0){
        this.planOwners = this.dataService.getPlanPrimarSecondaryOwners();
        this.planOwners.forEach(cl => {
          if(cl.role === fromModel.CLIENTROLE.Primary){
            this.pId = cl.clientid;
            this.pName = cl.clientname;
            this.pEmpType = this.refDataService.getPlanningUIRefDataByTypeCode(fromModel.PLANNINGUIREFTYPE.EmploymentTypes, cl.empType).value;
          } else if(cl.role === fromModel.CLIENTROLE.Secondary){
            this.sId = cl.clientid;
            this.sName = cl.clientname;
            this.sEmpType = this.refDataService.getPlanningUIRefDataByTypeCode(fromModel.PLANNINGUIREFTYPE.EmploymentTypes, cl.empType).value;
          }
        });        
      }
      this.planClients = this.dataService.getPlanClients();
      this.allClients = this.dataService.getAllClients();

      if(this.allClients) {
        this.allClients = this.allClients.filter(({LegalEntityID}) => LegalEntityID !== this.pId && LegalEntityID !== this.sId);

        this.allClients.forEach(cl => {
          const planClient = this.planClients.find(plCl=>plCl.clientid === cl.LegalEntityID);
          if(planClient){
            cl.isIncluded  = true;
          } else {
            cl.isIncluded  = false;
          }
        });
      }

      let goalsRef: fromModel.CodeValue[] = [];
      let goalId='';
      let priority=0;
      let color='';
      let amount = 0;
      this.goals = [];

      goalsRef  = this.refDataService.getPlanningUIRefDataByType(fromModel.PLANNINGUIREFTYPE.Goals);
      goalsRef.forEach(goalRef => {
        let _goal = this.plan.goals.find(goal=>goal.goalType === goalRef.code);
        
        goalId = '';
        if(_goal){
          goalId = _goal.goalId;
          
          amount = this.dataService.getGoalAmountByGoalType(_goal.goalType);
        } else {
          goalId = '';
          amount = undefined;
        }
        color = this.refDataService.getPlanningUIRefDataByTypeCode(fromModel.PLANNINGUIREFTYPE.GoalsColor, goalRef.code).value;
        this.goals.push({goalId: goalId, goalType: goalRef.code, goalDesc: goalRef.value, priority: priority, amount: amount, color: color});      
      });



      // if(this.plan && this.plan.goals && this.plan.goals.length>0){
      //   this.goals = this.plan.goals;
      //   this.goals.forEach(goal => {  
      //     goal.amount = this.dataService.getGoalAmountByGoalType(goal.goalType);
      //     goal.color = this.refDataService.getPlanningUIRefDataByTypeCode(fromModel.PLANNINGUIREFTYPE.GoalsColor, goal.goalType).value;
      //   });
      // }

      this.incomeColor = this.refDataService.getPlanningUIRefDataByTypeCode(fromModel.PLANNINGUIREFTYPE.Colors, fromModel.COLORS.INCOME).value;
      if(this.plan && this.plan.incomes && this.plan.incomes.length>0){         
        this.totalIncome = this.dataService.getAllIncomeAmount();
        this.pEmpIncome = this.dataService.getEmpIncomeAmountByRole(fromModel.CLIENTROLE.Primary);
        this.sEmpIncome = this.dataService.getEmpIncomeAmountByRole(fromModel.CLIENTROLE.Secondary);
        
      }
      
      this.assetsColor = this.refDataService.getPlanningUIRefDataByTypeCode(fromModel.PLANNINGUIREFTYPE.Colors, fromModel.COLORS.ASSETS).value;
      this.taxableColor = this.refDataService.getPlanningUIRefDataByTypeCode(fromModel.PLANNINGUIREFTYPE.Colors, fromModel.COLORS.TAXABLE).value;
      this.taxDefColor = this.refDataService.getPlanningUIRefDataByTypeCode(fromModel.PLANNINGUIREFTYPE.Colors, fromModel.COLORS.TAXDEFERRED).value;
      this.taxExemptColor = this.refDataService.getPlanningUIRefDataByTypeCode(fromModel.PLANNINGUIREFTYPE.Colors, fromModel.COLORS.TAXEXEMPT).value;

      
      if(this.plan && this.plan.planAccounts && this.plan.planAccounts.length>0){   
        this.totalTaxableAssets = this.dataService.getPlanAccountTotalByTaxStatus(fromModel.TAXSTATUS.TAXABLE);
        this.totalTaxDefAssets = this.dataService.getPlanAccountTotalByTaxStatus(fromModel.TAXSTATUS.TAXDEFERRED);
        this.totalTaxExemptAssets = this.dataService.getPlanAccountTotalByTaxStatus(fromModel.TAXSTATUS.TAXEXEMPT);
      }

      this.uiStateService.dispatchAction(fromModel.UI_STATE_ACTION.SHOWPROGRESSBAR, "FamilyViewComponent-populateAppData", false);      
    }
  }

  selectGoal(goalId){
    //this.goalMenuTrigger.openMenu();
    this.goalId = goalId;    
  }

  // includeClientInPlan(clientid){
  //   let client = this.dataService.getClientByClientId(clientid);
  //   if(client){
  //   let selectedClient: fromModel.PlanClient = {
  //     clientid: client.LegalEntityID,
  //     clientname: client.LegalEntityName,
  //     initials: '',
  //     dob: client.dateofBirth,
  //     age: 0,
  //     // endAge?: number;
  //     // gender?: string;
  //     // stateOfResi?: string;    
  //     role: fromModel.CLIENTROLE.Other,
  //     // retAge?: number;
  //     // salary?: number;
  //     // empType?: EMPLOYMENTTYPE;
  //     isIncluded: true
  //   };
  //   }
    
  //   //this.dataService.dispatchAction(fromModel.DATA_ACTION.SELECTEDPLANCLIENT, "SavePlanComponent-includeClientInPlan", {id: '', planName: this.planName.value});
  // }

  addGoalExpense(goalType){
    this.openModelDialog(fromModel.OPENDIALOGACTIONS.EDITEXPENSE, '', goalType);
  }

  openModelDialog(action: fromModel.OPENDIALOGACTIONS, parm1?: string, parm2?: string){
    switch(action){
      case fromModel.OPENDIALOGACTIONS.ACCOUNTS: {
        const dialogRef = this.dialog.open(EditIncomeComponent, {
          width: '70%',
          height: '70%',
          data: {incType: parm1, clientid: parm2},
          //data: expense,
          disableClose: true    
          }).afterClosed()
          .subscribe(result => {
            if(result && result.isSaved && result.expense && result.expense.isIncluded){
              //this.refreshExpense(result.expense);              
              //this.UpdateIncome.emit();
            }
          });        
        break;
      }
      
      case fromModel.OPENDIALOGACTIONS.EDITEXPENSE: {
        const dialogRef = this.dialog.open(EditExpenseComponent, {
          width: '70%',
          height: '70%',
          data: {expenseId: parm1, goalType: parm2, expType: fromModel.EXPENSETYPE.OTH},
          //data: expense,
          disableClose: true    
          }).afterClosed()
          .subscribe(result => {
            if(result && result.isSaved){
              //this.refreshExpense(result.expense);
              //this.dataService.getGoalSummary();
            }
          });        
        break;
      }  

    }
  }

  openDialog(action: any){
    this.openModelDialog(action);
  }

  ngOnDestroy(): void{
    // if(this._storeAppContextSubscription && this._storeAppContextSubscription !== null){
    //   this._storeAppContextSubscription.unsubscribe();
    // }
    if(this._storeDataSubscription && this._storeDataSubscription !== null){
      this._storeDataSubscription.unsubscribe();
    }    
    // if(this._uiStateSubscription && this._uiStateSubscription !== null){
    //   this._uiStateSubscription.unsubscribe();    
    // }
  }

  
}
